// extracted by mini-css-extract-plugin
export default {"wrapper":"hB-z","button":"iB-z","alternate":"jB-z","disabled":"kB-z","paymentWarning":"lB-z","fadeIn":"mB-z"};